import React, { useState, useEffect } from 'react';
import { connect } from 'redux-zero/react';
import { combineActions } from 'redux-zero/utils';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { get, pick } from 'lodash';
import {
  vEmail,
  vMinLength,
  vIncludeUppercase,
  vIncludeLowercase,
  vIncludeNumber,
} from '@tokenyico/design-system';
import { DsForm, DsInputString, DsButton } from '@tokenyico/design-system/dist/reactJS';

import { formActions, holderActions } from 'app/state/actions';

import {
  AuthenticationService,
  HolderService,
  TokenService,
  //  MessageService,
  RedemptionService,
} from 'services';

const mapToProps = (state) => state;

const SignInAuthView = ({
  history,
  setError,
  setUser,
  location,
  setTokens,
  setSelectedToken,
  //  setMessages,
  setPendingRequests,
  setBalances,
  setRedemption,
}) => {
  const { t } = useTranslation();
  const [email, setEmail] = useState(null);
  const [password, setPassword] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (get(location, 'state.email')) {
      setEmail(get(location, 'state.email', ''));
    }
  }, [location]);

  const portalId = process.env.REACT_APP_PORTAL_ID;

  const onSubmit = async () => {
    try {
      setIsSubmitting(true);
      const user = await AuthenticationService.signIn({ username: email, password });
      let tokenId;
      // let tokenAddress;
      if (portalId) {
        const tokens = await TokenService.getTokens();
        if (tokens && tokens.length === 0) {
          throw new Error(t('validation.notAuthorizedRegistered'));
        }
        setTokens(tokens);
        const selectedToken = TokenService.getSelectedToken(tokens);
        setSelectedToken(selectedToken);
        tokenId = selectedToken.id;
        // tokenAddress = selectedToken.address;
      } else {
        tokenId = process.env.REACT_APP_TOKEN_ID;
        const balances = await HolderService.getBalances(tokenId);
        setBalances(balances);
        setSelectedToken(get(balances, '[0].token', null));
        // tokenAddress = get(balances, '[0].token.address', null);
      }

      const currentTokenHolder = await HolderService.getTokenHolder(tokenId);
      if (currentTokenHolder && currentTokenHolder.status === 'Registered') {
        throw new Error(t('validation.notAuthorizedRegistered'));
      }
      setUser({ ...user, ...pick(currentTokenHolder, 'status') });

      // messages is disabled
      // MessageService.getAllMessages(tokenAddress).then(setMessages);

      TokenService.getTokenRequestsMeReceived(tokenId, {
        limit: 50,
        offset: 0,
        sortBy: null,
        sortDirection: null,
        filter: {
          status: 'PENDING_APPROVAL',
        },
      }).then(({ itemsReturned }) => setPendingRequests(itemsReturned));

      try {
        const redemption = await RedemptionService.getRedemptions(tokenId);
        setRedemption(redemption);
      } catch (e) {
        setRedemption(false);
        // 404 expected
      }

      history.push('/dashboard');
      setIsSubmitting(false);
    } catch (error) {
      setIsSubmitting(false);
      if (error.code === 'UserNotConfirmedException') {
        history.push('/auth/confirm-signup', { email });
        setError(error);
      } else if (
        error.code === 'PasswordResetRequired' ||
        error.message === 'PasswordResetRequired'
      ) {
        setError(t('validation.passwordResetRequired'));
        history.push('/auth/reset-password');
      } else if (error.code === 'mfaEnable' || error.message === 'mfaEnabled') {
        setError(t('validation.mfaEnabled'));
      } else {
        setError(error);
        await AuthenticationService.signOut();
      }
    }
  };

  return (
    <div className="card auth">
      <h1 className="auth__title">{t('shared.signIn')}</h1>
      <DsForm onSubmit={onSubmit} id="sign-in">
        <DsInputString
          label={t('shared.email')}
          isFloatLabel={false}
          name="email"
          type="email"
          value={email}
          onDsInput={({ detail }) =>
            setEmail(typeof detail === 'string' ? detail.toLocaleLowerCase() : detail)
          }
          validate={vEmail}
          className="_m:top(2)"
        />
        <DsInputString
          label={t('shared.password')}
          isFloatLabel={false}
          name="password"
          type="password"
          value={password}
          onDsInput={({ detail }) => setPassword(detail)}
          validate={(v) =>
            vMinLength(8)(v) || vIncludeUppercase(v) || vIncludeLowercase(v) || vIncludeNumber(v)
          }
          className="_m:top(3)"
        />

        <div className="auth__button-primary">
          <DsButton
            version="primary"
            label={t('shared.signIn')}
            type="submit"
            isLoading={isSubmitting}
            icon="arrow-right"
            iconHeight={11}
          />
        </div>
        <div className="auth__button-secondary">
          <Link to="/auth/forgot-password">
            <DsButton label={t('shared.forgotPassword')} mode="text" id="forgot-password" />
          </Link>
        </div>
      </DsForm>
      <div className="auth__footer">
        <Link to="/auth/signup">
          <DsButton label={t('shared.createAccount')} mode="text" />
        </Link>
      </div>
    </div>
  );
};

export default connect(mapToProps, combineActions(formActions, holderActions))(SignInAuthView);
